export const DD_FETCH_DATES = 'DD_FETCH_DATES';
export const DD_CREATE_DATE = 'DD_CREATE_DATE';
export const DD_UPDATE_DATE = 'DD_UPDATE_DATE';
export const DD_DELETE_DATE = 'DD_DELETE_DATE';
export const DD_CREATE_DATE_ENTRY = 'DD_CREATE_DATE_ENTRY';
export const DD_UPDATE_DATE_ENTRY = 'DD_UPDATE_DATE_ENTRY';
export const DD_DELETE_DATE_ENTRY = 'DD_DELETE_DATE_ENTRY';
export const DD_FETCH_MAPPED_DATES = 'DD_FETCH_MAPPED_DATES';
